import { legacySalaToNew } from "@/lib/quote";

export const SalaSelector = ({ q, updateSala }) => {
  const s = legacySalaToNew(q.sala, { rooms: "interna" });
  return (
    <div>
      <h3 className="text-xs font-bold uppercase tracking-widest text-[#C85A32] mb-2">Sala & esclusività</h3>
      <div className="flex gap-2 items-center flex-wrap">
        <select data-testid="admin-sala-rooms" value={s.rooms || "interna"} onChange={(e) => updateSala({ rooms: e.target.value })}
          className="h-9 rounded-md bg-[#1E293B] border border-slate-700 text-sm px-2">
          <option value="interna">Sala Interna</option>
          <option value="deorsi">Sala Dehors</option>
          <option value="entrambe">Entrambe le sale</option>
        </select>
        {(s.rooms === "interna" || s.rooms === "entrambe") && (
          <label className="flex items-center gap-1.5 text-xs cursor-pointer">
            <input data-testid="admin-excl-interna" type="checkbox" className="w-4 h-4 accent-[#C85A32]" checked={!!s.excl_interna} onChange={(e) => updateSala({ excl_interna: e.target.checked })} />
            Esclusiva Interna
          </label>
        )}
        {(s.rooms === "deorsi" || s.rooms === "entrambe") && (
          <label className="flex items-center gap-1.5 text-xs cursor-pointer">
            <input data-testid="admin-excl-deorsi" type="checkbox" className="w-4 h-4 accent-[#C85A32]" checked={!!s.excl_deorsi} onChange={(e) => updateSala({ excl_deorsi: e.target.checked })} />
            Esclusiva Dehors
          </label>
        )}
        <span className="text-xs text-slate-400">Il costo esclusiva viene ricalcolato nel preventivo.</span>
      </div>
    </div>
  );
};
